import { render } from "./shop.vue?vue&type=template&id=987e7ff8&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"

import "./shop.vue?vue&type=style&index=0&id=987e7ff8&scoped=true&lang=css"

import exportComponent from "D:\\Code\\mt\\Agent\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-987e7ff8"]])

export default __exports__